import { AfterViewInit, Component } from '@angular/core';
import {
  IFRAME_EXTERNAL_ID_PROVIDER_CHECK_VALUE,
  IFRAME_EXTERNAL_ID_PROVIDER_INIT_MESSAGE,
} from 'constants/auth.constants';
import { TokenService } from 'services/token/token.service';
import { LOGIN_PROVIDER_VERIFY_STATUS, SIGN_IN_TYPES } from 'pages/entry/entry.helpers';
import { ExternalLoginSettings } from 'interfaces/external-login.interface';

@Component({
  selector: 'cm-external-id-provider-form',
  templateUrl: './external-id-provider-form.component.html',
  styleUrls: ['./external-id-provider-form.component.scss'],
})
export class ExternalIdProviderFormComponent implements AfterViewInit {
  private _origin: string = '*';
  private _verifyUserByToken: boolean = false;
  isLoaded = false;

  readonly SIGN_IN_TYPES = SIGN_IN_TYPES;

  settings: ExternalLoginSettings = null;

  constructor(private tokenService: TokenService) {}

  ngAfterViewInit() {
    window.addEventListener(
      'message',
      event => {
        if (event.data) {
          const { [IFRAME_EXTERNAL_ID_PROVIDER_INIT_MESSAGE]: checkKey, verifyUserByToken, settings } = event.data;
          if (checkKey) {
            this.isLoaded = true;
            this._origin = event.origin;
            this._verifyUserByToken = verifyUserByToken;
            this.settings = settings;
            this.correctHeight();
          }
        }
      },
      false,
    );
  }

  correctHeight() {
    if (!this.settings[SIGN_IN_TYPES.GOOGLE] || this.settings[SIGN_IN_TYPES.GOOGLE].enabled) {
      // Waiting for google button to load
      (window as any).onGoogleLibraryLoad = () => {
        this.postMessage({
          status: LOGIN_PROVIDER_VERIFY_STATUS.SUCCESS,
          height: document.querySelector('.social-login').scrollHeight,
        });
      };
    } else {
      // if there isn't google button and no need to wait
      setTimeout(() => {
        this.postMessage({
          status: LOGIN_PROVIDER_VERIFY_STATUS.SUCCESS,
          height: document.querySelector('.social-login').scrollHeight,
        });
      });
    }
  }

  googleCallback(msg) {
    if (this._verifyUserByToken) {
      this.tokenService
        .verifyUserByToken(msg.credential, SIGN_IN_TYPES.GOOGLE)
        .subscribe(res => this.postGoogleMessage(res), () => this.postGoogleMessage(msg, true));
    }
    this.postGoogleMessage(msg);
  }

  extProviderClick(type: SIGN_IN_TYPES) {
    this.postMessage({
      status: LOGIN_PROVIDER_VERIFY_STATUS.SUCCESS,
      type,
    });
  }

  private postGoogleMessage(msg, hasError = false) {
    this.postMessage({
      ...msg,
      status: hasError ? LOGIN_PROVIDER_VERIFY_STATUS.FAIL : LOGIN_PROVIDER_VERIFY_STATUS.SUCCESS,
      type: SIGN_IN_TYPES.GOOGLE,
    });
  }

  private postMessage(msg) {
    window.top.postMessage(
      {
        ...msg,
        [IFRAME_EXTERNAL_ID_PROVIDER_CHECK_VALUE]: true,
      },
      this._origin,
    );
  }
}
